import { useQuery } from '@tanstack/vue-query'
import KnownError from '~/exceptions/KnownError'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useGetShoppingCartId(projectId: string, enabled: Ref<boolean>) {
  const queryKey = queryKeys.SIMULATION.GET_SHOPPING_CART_ID(projectId)

  const queryFn = async () => {
    if (enabled.value) {
      const response = await financialBff('query')({
        simulation_project_shopping_cart_id_get: [
          { projectId },
          true,
        ],
      })
      return response.simulation_project_shopping_cart_id_get
    }
  }

  return useQuery({
    queryKey,
    queryFn,
    staleTime: 1000 * 60 * 5,
    retry: (failureCount, error) => {
      if (error instanceof KnownError && error.message === 'NOT_FOUND') {
        return false
      }
      return failureCount < 3
    },
    enabled: () => enabled.value,
  })
}
